import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c387378"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = ["type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.type === 'anchor')
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: _normalizeClass(["button--container", _ctx.containerClasses]),
        style: _normalizeStyle(_ctx.containerStyles),
        href: _ctx.href,
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buttonMouseDownHandler && _ctx.buttonMouseDownHandler(...args))),
        onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.buttonMouseUpHandler && _ctx.buttonMouseUpHandler(...args))),
        onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveHandler && _ctx.mouseLeaveHandler(...args))),
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["button--label", {'material-icons': _ctx.icon}])
        }, _toDisplayString(_ctx.label), 3 /* TEXT, CLASS */),
        _createElementVNode("span", {
          class: "button--ripple",
          onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.buttonRippleAnimationEndHandler && _ctx.buttonRippleAnimationEndHandler(...args)))
        }, null, 32 /* HYDRATE_EVENTS */),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_1))
    : (_ctx.type === 'router-link')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: _ctx.href,
          class: _normalizeClass(["button--container", _ctx.containerClasses]),
          style: _normalizeStyle(_ctx.containerStyles),
          onMousedown: _ctx.buttonMouseDownHandler,
          onMouseup: _ctx.buttonMouseUpHandler,
          onMouseleave: _ctx.mouseLeaveHandler,
          onClick: _ctx.clickHandler
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["button--label", {'material-icons': _ctx.icon}])
            }, _toDisplayString(_ctx.label), 3 /* TEXT, CLASS */),
            _createElementVNode("span", {
              class: "button--ripple",
              onAnimationend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.buttonRippleAnimationEndHandler && _ctx.buttonRippleAnimationEndHandler(...args)))
            }, null, 32 /* HYDRATE_EVENTS */),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["to", "class", "style", "onMousedown", "onMouseup", "onMouseleave", "onClick"]))
      : (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: _normalizeClass(["button--container", _ctx.containerClasses]),
          type: _ctx.type,
          style: _normalizeStyle(_ctx.containerStyles),
          onMousedown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.buttonMouseDownHandler && _ctx.buttonMouseDownHandler(...args))),
          onMouseup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.buttonMouseUpHandler && _ctx.buttonMouseUpHandler(...args))),
          onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveHandler && _ctx.mouseLeaveHandler(...args))),
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clickHandler && _ctx.clickHandler(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["button--label", {'material-icons': _ctx.icon}])
          }, _toDisplayString(_ctx.label), 3 /* TEXT, CLASS */),
          _createElementVNode("span", {
            class: "button--ripple",
            onAnimationend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.buttonRippleAnimationEndHandler && _ctx.buttonRippleAnimationEndHandler(...args)))
          }, null, 32 /* HYDRATE_EVENTS */),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_2))
}